import { useCallback, useEffect, useRef, useState } from 'react';
import { ExtendedState } from './useExtendedState';

function useExtendedArrayState(initialValue) {
    const initialValueRef = useRef(initialValue || null);
    const [items, setItems] = useState([]);
    const valueSetter = useCallback((index) => (newValue) => {
        const newItems = [...items];
        newItems[index] = buildExtendedArrayItem(index, new ExtendedState(initialValueRef.current, newValue));
        setItems(newItems);
    },[items]);

    useEffect(() => {
        items.forEach((value, index) => {
            value.value.valueSetter = valueSetter(index);
        });
    }, [items, valueSetter]);

    return {
        items: items,
        resize: useCallback((newSize) => {
            if (newSize !== items.length) {
                const newValues = [];
                for (let i = 0; i < newSize; ++i) {
                    const oldValue = items[i];
                    newValues[i] = oldValue || buildExtendedArrayItem(i, new ExtendedState(initialValueRef.current));
                }
                setItems(newValues);
            }
        }, [items]),
        reset: () => {
            const newValues = [];
            for (let i = 0 ; i < items.length ; ++i) {
                newValues[i] = buildExtendedArrayItem(i, new ExtendedState(initialValueRef.current));
            }
            setItems(newValues);
        }
    };
}

function buildExtendedArrayItem(id, value) {
    return { id, value };
}

export default useExtendedArrayState;
